import Image from "next/image";
import Link from "next/link";
import SearchIcon from "@mui/icons-material/Search";
import React, { createRef } from "react";
import { useState } from "react";
import { FAQ_SLUG, MARKET_INSIGHTS_ENABLED } from "@/constastants/Constant";
import { usePathname } from "next/navigation";
import { motion } from "framer-motion";
import SearchMenu from "./SearchMenu";
import MenuIcon from "@mui/icons-material/Menu";
import MobileMenu from "./MobileMenu";
import HoverMenu from "./HoverMenu/HoverMenu";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ClearIcon from "@mui/icons-material/Clear";
import { getCDNImageUrl, getIntlUrl as getIntlUrlUtil } from "@/utils/Common";

export const menus = [
  {
    name: "Products",
    Items: [],
    url: "/product",
  },
  {
    name: "Custom Manufacturing",
    Items: [],
    url: "/quality-custom-chemical-manufacturing",
  },
  {
    name: "Our Technology",
    Items: [],
    url: "/elchemy-tech",
  },
  {
    name: "About Us",
    Items: [],
    url: "/about-us",
  },
  {
    name: "Insights",
    url: "/insights",
    Items: [
      {
        url: "/events",
        title: "Events",
      },
      {
        url: "/blogs",
        title: "Blogs",
      },
      ...(MARKET_INSIGHTS_ENABLED
        ? [{ url: "/market-insights", title: "Market Insights" }]
        : []),
      {
        url: `/${FAQ_SLUG}`,
        title: "FAQs",
      },
    ],
  },
  {
    name: "Contact Us ",
    url: "/contact-elchemy",
    Items: [
      {
        url: "/careers",
        title: "Careers",
      },
      {
        url: "/contact-elchemy",
        title: "Contact Us",
      },
    ],
  },
];

export const navbarRef = createRef();

const Header = () => {
  const [openMobileMenu, setopenMobileMenu] = useState(false);
  const [openMenu, setopenMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [searchMenu, setSearchMenu] = useState(false);
  const pathname = usePathname();

  const { bg } = useSelector((state) => state.Blog);

  const makeMenuActive = (index) => {
    setActiveMenu(index);
  };

  const handleSearchOpen = () => {
    setSearchMenu(true);
  };

  const closeMemnu = () => {
    setopenMenu(false);
    setSearchMenu(false);
  };

  const closeMobileMenu = () => {
    setopenMobileMenu(false);
  };

  let activeLinkTwo = null;
  let activeLinkOne = null;

  activeLinkTwo = ["/careers", "/contact-elchemy"].includes(pathname);
  activeLinkOne =
    pathname?.startsWith(`/${FAQ_SLUG}`) ||
    pathname?.startsWith("/blogs") ||
    ["/events", "/market-insights"].includes(pathname);

  const isIntl = pathname?.endsWith("/intl");
  const getIntlUrl = (url) => getIntlUrlUtil(url, isIntl);

  const openCalendlyLink = () => {
    if (window) {
      window.open("https://calendly.com/elchemy/team", "_blank");
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 1, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, type: "spring", stiffness: 20, delay: 0 }}
        //remove marginTop if you want to remove the banner
        style={{
          zIndex: "1000",
          background: bg ? "#ffff" : "",
          boxShadow: bg ? "0px 4px 12px 0px #00000014" : "",
          top: bg ? "0px" : "0px",
          transition: bg ? "all 300ms ease-out" : "",
          width: "100%",
          position:
            pathname === "/" ? (bg ? "fixed" : "absolute") : !bg && "sticky",
        }}
      >
        {/* <div className="mb-0 p-2 bg-[#009999] text-[#ffffff] flex items-center justify-center cursor-pointer ">
          <div className="text-center banner">
            Meet the Elchemists at ChemExpo India 2025, Mumbai | 29th and 30th
            April | Hall 06 Stall 6D07.{" "}
            <a
              href="https://calendly.com/elchemy/team?month=2025-04&date=2025-04-29"
              className="hover:underline hover:text-white"
              target="_blank"
            >
              Reserve Your Meeting Now!
            </a>
          </div>s
        </div> */}
        <div
          className={`${openMobileMenu ? "h-full]" : ""} ${
            pathname !== "/" ? "bg-white header-shadow" : ""
          } `}
        >
          {openMobileMenu && (
            <MobileMenu closeMobileMenu={closeMobileMenu} bg={bg} />
          )}

          <div
            className={`searchMenuCon relative ${
              openMenu && "searchMenuConClicked"
            }`}
          >
            {searchMenu && (
              <>
                <SearchMenu closeMemnu={closeMemnu} />
              </>
            )}
          </div>

          <div>
            {typeof window !== undefined && (
              <div
                className="lg:flex justify-between hidden lg:px-[7.5rem] md:py-[1.2rem] lg:flex-row md:flex-col items-center"
                style={{ alignItems: "center" }}
              >
                <Link
                  href={getIntlUrl("/")}
                  passHref={true}
                  className="lg:w-[15%] "
                >
                  {pathname === "/" ? (
                    <>
                      <Image
                        src={`${
                          bg
                            ? getCDNImageUrl("elchemylogo.svg")
                            : getCDNImageUrl("whitelogo.svg")
                        }`}
                        alt="logo"
                        width="119"
                        height="44"
                      />
                    </>
                  ) : (
                    <>
                      <Image
                        src={getCDNImageUrl("elchemylogo.svg")}
                        alt="logo"
                        width="119"
                        height="44"
                      />
                    </>
                  )}
                </Link>

                <div className="flex md:ml-auto md:mr-auto   lg:ml-0 lg:mr-0   lg:flex-row justify-end items-center md:mt-0 mt-10 md:flex-col flex-col w-[80%]">
                  {menus?.length > 0 &&
                    menus.map((menu, i) => {
                      return (
                        <>
                          {
                            <>
                              <li
                                key={i}
                                className={`list-none ${
                                  i === 4 || i === 5 ? "hidden" : ""
                                } ${
                                  pathname === "/"
                                    ? bg
                                      ? "text-[#000]"
                                      : "text-[#FFFFFF]"
                                    : ` ${
                                        `/${pathname?.split("/")[1]}` ===
                                        menu?.url
                                          ? " text-[#ef4136] "
                                          : "text-[#161616]"
                                      }`
                                } md:text-[14px]  md:mt-5 lg:mt-0 mt-5 pl-8  cursor-pointer   text-base  font-medium`}
                              >
                                <Link
                                  href={getIntlUrl(menu?.url) || ""}
                                  passHref={true}
                                  target={menu?.openNewTab ? "_blank" : ""}
                                  onClick={() => {
                                    makeMenuActive(i);
                                  }}
                                >
                                  <p className="md:text-center">{menu.name}</p>
                                </Link>
                              </li>
                              <li
                                key={i}
                                className={`list-none ${
                                  i === 4 ? "" : "hidden"
                                } 
                      
                               md:text-[14px] text-[#FFFFFF]  md:mt-5 lg:mt-0 mt-5 pl-8  cursor-pointer   text-[14px]  font-medium `}
                              >
                                <HoverMenu
                                  listItem={menu.Items}
                                  isIntl={isIntl}
                                >
                                  <div
                                    className={`${
                                      pathname === "/"
                                        ? bg
                                          ? "text-[#000]"
                                          : "text-[#FFFFFF]"
                                        : ` ${
                                            activeLinkOne
                                              ? "text-[#ef4136]"
                                              : "text-[#161616]"
                                          }`
                                    }`}
                                  >
                                    {menu.name}{" "}
                                    <KeyboardArrowDownIcon
                                      className={`${
                                        pathname === "/"
                                          ? bg
                                            ? "text-[#000]"
                                            : "text-[#FFFFFF]"
                                          : ` ${
                                              activeLinkOne
                                                ? " text-red-400 "
                                                : "text-[#161616]"
                                            }`
                                      }`}
                                    />
                                  </div>
                                </HoverMenu>
                              </li>
                              <li
                                key={i}
                                className={`list-none ${
                                  i === 5 ? "" : "hidden"
                                } 
                      
                               md:text-[14px] text-[#FFFFFF]  md:mt-5 lg:mt-0 mt-5 pl-8  cursor-pointer   text-base  font-medium `}
                              >
                                <HoverMenu
                                  listItem={menu.Items}
                                  isIntl={isIntl}
                                >
                                  <Link
                                    href={getIntlUrl("/contact-elchemy")}
                                    passHref={true}
                                    className={`${
                                      pathname === "/"
                                        ? bg
                                          ? "text-[#000]"
                                          : "text-[#FFFFFF]"
                                        : ` ${
                                            activeLinkTwo
                                              ? " text-red "
                                              : "text-[#161616]"
                                          }`
                                    }`}
                                  >
                                    {menu.name}{" "}
                                    <KeyboardArrowDownIcon
                                      className={`${
                                        pathname === "/"
                                          ? bg
                                            ? "text-[#000]"
                                            : "text-[#FFFFFF]"
                                          : ` ${
                                              activeLinkTwo
                                                ? "text-[#ef4136]"
                                                : "text-[#161616]"
                                            }`
                                      }`}
                                    />
                                  </Link>
                                </HoverMenu>
                              </li>
                            </>
                          }
                        </>
                      );
                    })}
                  <li key={"icon-search"} className="flex">
                    <div
                      className=" w-[2.5rem] ml-8 h-[2.5rem] bg-red rounded flex justify-center items-center relative mr-1 cursor-pointer"
                      style={{ borderRadius: "50%" }}
                      onClick={() => setSearchMenu(true)}
                    >
                      <SearchIcon style={{ color: "white" }} />
                    </div>
                  </li>
                </div>
                <div></div>
              </div>
            )}
          </div>

          <div className=" py-[1rem]  flex justify-between px-4  lg:hidden items-center">
            <div className="flex">
              <div
                className="pr-[1rem]"
                onClick={() => {
                  setopenMobileMenu(true);
                }}
              >
                <MenuIcon
                  style={{
                    color: `${pathname === "/" && !bg ? "white" : "black"}`,
                    cursor: "pointer",
                    marginTop: bg ? "0.4rem" : "0.2rem",
                  }}
                />
              </div>
              <Link
                href={getIntlUrl("/")}
                passHref={true}
                className="lg:w-[15%]"
              >
                <Image
                  src={`${
                    pathname === "/" && !bg
                      ? getCDNImageUrl("whitelogo.svg")
                      : getCDNImageUrl("elchemylogo.svg")
                  }`}
                  alt="logo"
                  width="119"
                  height="44"
                />
              </Link>
            </div>
            {/* <div
            className="pr-[1rem]"
            onClick={() => {
              setopenMobileMenu(true)
            }}
          >
            <MenuIcon
              style={{
                color: `${pathname === "/" && !bg ? "white" : "black"}`,
                cursor: "pointer",
              }}
            />
          </div> */}
            <div
              className=" w-[2.5rem] h-[2.5rem] bg-red rounded flex justify-center items-center relative mr-1 cursor-pointer "
              style={{ borderRadius: "50%" }}
              onClick={handleSearchOpen}
            >
              <SearchIcon style={{ color: "white" }} />
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Header;
